import { useI18n } from "../i18n/I18nProvider";
import { usePreferences } from "../preferences/usePreferences";

export function LanguageSettings() {
  const { t, locale } = useI18n();
  const { save, busy, error } = usePreferences();
  return (
    <section className="settings-card">
      <h2>{t("语言", "Language")}</h2>
      <label>
        {t("偏好语言", "Preferred language")}
        <select value={locale} disabled={busy}
          onChange={(event) => void save({ locale: event.target.value as "zh-CN" | "en" }).catch(() => {})}>
          <option value="zh-CN">简体中文</option>
          <option value="en">English</option>
        </select>
      </label>
      <p className="muted">{t(
        "界面立即切换；新文字回复使用新语言，语音和持续陪伴会谈在下次连接或会谈生效。历史对话保留原文，模型的语言支持可能有限。",
        "The interface changes immediately. New text replies use the selected language; voice and courses apply it at the next connection or session. Existing messages keep their original language. Model language support may vary."
      )}</p>
      {busy && <p role="status" className="muted">{t("正在保存偏好…", "Saving preferences…")}</p>}
      {error && <p role="alert" className="notice error">{error}</p>}
    </section>
  );
}
